import { Pipe, PipeTransform } from '@angular/core';
import { SaleOrderStatus } from '../enums/sale-order-status.enum';
import { getVintedGoStatusLabels } from '../helpers/vintedgo-status-label.util';

@Pipe({
  name: 'deliveryStatusLabel',
  pure: true
})
export class DeliveryStatusLabelPipe implements PipeTransform {

  private readonly statusLabels: Record<number, string> = {
    // --- Legacy / Core Statuses (0-38) ---
    [SaleOrderStatus.NEW]: 'New',
    [SaleOrderStatus.PAID]: 'Paid',
    [SaleOrderStatus.COLLECTED]: 'Collected',
    [SaleOrderStatus.IN_TRANSIT]: 'In Transit',
    [SaleOrderStatus.DELIVERED]: 'Delivered',
    [SaleOrderStatus.PENDING_COLLECTION]: 'Pending Collection',
    [SaleOrderStatus.PENDING_CUSTOMER_COLLECTION]: 'Pending Customer Collection',
    [SaleOrderStatus.DELIVERY_ATTEMPT_FAILED]: 'Delivery Attempt Failed',
    [SaleOrderStatus.DELIVERY_ADDRESS_CHANGED]: 'Delivery Address Changed',
    [SaleOrderStatus.DELIVERY_REFUSED]: 'Delivery Refused',
    [SaleOrderStatus.CUSTOM_DELAY]: 'Customs Delay',
    [SaleOrderStatus.SHIPMENT_DELAYED]: 'Shipment Delayed',
    [SaleOrderStatus.DELAYED_DUE_PAYMENT]: 'Delayed Due to Payment',
    [SaleOrderStatus.INCORRECT_ADDRESS]: 'Incorrect Address',
    [SaleOrderStatus.SHIPMENT_REJECTED]: 'Shipment Rejected',
    [SaleOrderStatus.SHIPMENT_RETURNED]: 'Shipment Returned',
    [SaleOrderStatus.SHIPMENT_LOST]: 'Shipment Lost',
    [SaleOrderStatus.SHIPMENT_ARRIVED_DESTINATION_PORT]: 'Arrived at Destination Port',
    [SaleOrderStatus.CUSTOM_CLEARED]: 'Customs Cleared',
    [SaleOrderStatus.CUSTOM_CLEARANCE_PROCESS]: 'Customs Clearance Process',
    [SaleOrderStatus.SHIPMENT_BACK_2_TRANSIT]: 'Back in Transit',
    [SaleOrderStatus.NEW_ADDRESS_RECEIVED]: 'New Address Received',
    [SaleOrderStatus.DELIVERY_IN_PROCESS]: 'Delivery in Process',
    [SaleOrderStatus.SHIPMENT_CANCELED]: 'Shipment Canceled',
    [SaleOrderStatus.DELAYED]: 'Delayed',
    [SaleOrderStatus.PENDING_DELIVERY]: 'Pending Delivery',
    [SaleOrderStatus.CANCELED]: 'Canceled',
    [SaleOrderStatus.UPDATE]: 'Update Required',
    [SaleOrderStatus.REORDER]: 'Reorder',
    [SaleOrderStatus.EARLY_CANCELATION]: 'Early Cancelation',
    [SaleOrderStatus.PENDING]: 'Pending',
    [SaleOrderStatus.ABANDODED_CHECKOUT]: 'Abandoned Checkout',
    [SaleOrderStatus.PAYMENT_DECLINED]: 'Payment Declined',
    [SaleOrderStatus.CLOSED]: 'Closed',
    [SaleOrderStatus.PARTIAL_SHIPMENT]: 'Partial Shipment',
    [SaleOrderStatus.PARTIAL_CANCELATION]: 'Partial Cancelation',
    [SaleOrderStatus.FULL_REFUND]: 'Full Refund',
    [SaleOrderStatus.PARTIAL_REFUND]: 'Partial Refund',

    // --- AfterShip Pending (101-106) ---
    [SaleOrderStatus.PENDING_001]: 'Pending',
    [SaleOrderStatus.PENDING_002]: 'Carrier account not connected',
    [SaleOrderStatus.PENDING_003]: 'Label created, no updates yet',
    [SaleOrderStatus.PENDING_004]: 'Wrong carrier',
    [SaleOrderStatus.PENDING_005]: 'No recent updates',
    [SaleOrderStatus.PENDING_006]: 'Unrecognized carrier',

    // --- AfterShip Info Received (111) ---
    [SaleOrderStatus.INFORECEIVED_001]: 'Info Received',

    // --- AfterShip In Transit (121-129) ---
    [SaleOrderStatus.INTRANSIT_001]: 'In Transit',
    [SaleOrderStatus.INTRANSIT_002]: 'Acceptance scan',
    [SaleOrderStatus.INTRANSIT_003]: 'Arrival scan',
    [SaleOrderStatus.INTRANSIT_004]: 'Arrived at the destination country/region',
    [SaleOrderStatus.INTRANSIT_005]: 'Customs clearance completed',
    [SaleOrderStatus.INTRANSIT_006]: 'Customs clearance started',
    [SaleOrderStatus.INTRANSIT_007]: 'Departure Scan',
    [SaleOrderStatus.INTRANSIT_008]: 'Problem resolved',
    [SaleOrderStatus.INTRANSIT_009]: 'Forwarded to a different delivery address',

    // --- AfterShip Out for Delivery (131-134) ---
    [SaleOrderStatus.OUTFORDELIVERY_001]: 'Out for Delivery',
    [SaleOrderStatus.OUTFORDELIVERY_003]: 'Customer contacted',
    [SaleOrderStatus.OUTFORDELIVERY_004]: 'Delivery appointment scheduled',

    // --- AfterShip Attempt Fail (141-143) ---
    [SaleOrderStatus.ATTEMPTFAIL_001]: 'Failed Attempt',
    [SaleOrderStatus.ATTEMPTFAIL_002]: 'Addressee not available',
    [SaleOrderStatus.ATTEMPTFAIL_003]: 'Business Closed',

    // --- AfterShip Delivered (151-154) ---
    [SaleOrderStatus.DELIVERED_001]: 'Delivered',
    [SaleOrderStatus.DELIVERED_002]: 'Picked up by the customer',
    [SaleOrderStatus.DELIVERED_003]: 'Sign by customer',
    [SaleOrderStatus.DELIVERED_004]: 'Delivered and received cash on delivery',

    // --- AfterShip Available for Pickup (161) ---
    [SaleOrderStatus.AVAILABLEFORPICKUP_001]: 'Ready for pickup',

    // --- AfterShip Exceptions (171-184) ---
    [SaleOrderStatus.EXCEPTION_001]: 'Exception',
    [SaleOrderStatus.EXCEPTION_002]: 'Customer moved',
    [SaleOrderStatus.EXCEPTION_003]: 'Customer refused delivery',
    [SaleOrderStatus.EXCEPTION_004]: 'Delayed (Customs clearance)',
    [SaleOrderStatus.EXCEPTION_005]: 'Delayed (External factors)',
    [SaleOrderStatus.EXCEPTION_006]: 'Held for payment',
    [SaleOrderStatus.EXCEPTION_007]: 'Incorrect Address',
    [SaleOrderStatus.EXCEPTION_008]: 'Pick up missed',
    [SaleOrderStatus.EXCEPTION_009]: 'Rejected by carrier',
    [SaleOrderStatus.EXCEPTION_010]: 'Returning to sender',
    [SaleOrderStatus.EXCEPTION_011]: 'Returned to sender',
    [SaleOrderStatus.EXCEPTION_012]: 'Shipment damage',
    [SaleOrderStatus.EXCEPTION_013]: 'Shipment lost',
    [SaleOrderStatus.EXCEPTION_014]: 'Carrier pickup failed',

    // --- AfterShip Expired (191) ---
    [SaleOrderStatus.EXPIRED_001]: 'Expired',

    // --- VintedGo statuses (192-219) — labels from Vinted status_code ---
    ...getVintedGoStatusLabels(SaleOrderStatus),

    // --- Shipping revolution statuses (220-249) ---
    [SaleOrderStatus.ORDER_CREATED]: 'Order Created',
    [SaleOrderStatus.PRE_ADVISED]: 'Pre Advised',
    [SaleOrderStatus.PICKED_UP]: 'Picked Up',
    [SaleOrderStatus.READY_FOR_PICKUP]: 'Ready for Pickup',
    [SaleOrderStatus.OUT_FOR_DELIVERY]: 'Out for Delivery',
    [SaleOrderStatus.EXCEPTION]: 'Exception',
    [SaleOrderStatus.DELIVERY_FAILED]: 'Delivery Failed',
    [SaleOrderStatus.TRACKING_UNAVAILABLE]: 'Tracking Unavailable',
    [SaleOrderStatus.RETURNED]: 'Returned',
    [SaleOrderStatus.ARRIVED_AT_TRANSIT_CENTER]: 'Arrived at Transit Center',
    [SaleOrderStatus.DEPARTED_TRANSIT_CENTER]: 'Departed Transit Center',
    [SaleOrderStatus.ARRIVED_AT_DELIVERY_STATION]: 'Arrived at Delivery Station',
    [SaleOrderStatus.DEPARTED_DELIVERY_STATION]: 'Departed Delivery Station',
    [SaleOrderStatus.RECEIVED_BY_COURIER]: 'Received by Courier',
    [SaleOrderStatus.DELIVERY_EXCEPTION]: 'Delivery Exception',
    [SaleOrderStatus.RETURNED_TO_TRANSIT_CENTER]: 'Returned to Transit Center',
    [SaleOrderStatus.RETURN_AWAITING_LOADING]: 'Return Awaiting Loading',
    [SaleOrderStatus.RETURN_RECEIVED]: 'Return Received',
    [SaleOrderStatus.CONFIRMED_LOST]: 'Confirmed Lost',
    [SaleOrderStatus.CONFIRMED_STOLEN]: 'Confirmed Stolen',
  };

  transform(value: number | string): string {
    const statusNumber = typeof value === 'string' ? parseInt(value, 10) : value;
    return this.statusLabels[statusNumber] || `Unknown (${statusNumber})`;
  }
}